/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.30/esri/copyright.txt for details.
*/
import{empty as t}from"../../../geometry/support/aaBoundingRect.js";class e{constructor(e="scene"){this.context=e,this.extent=t()}}export{e as ElevationUpdateEvent};
